var map = {
	"./1.png": 2383,
	"./1.webp": 8090,
	"./2.webp": 4458,
	"./3.webp": 4405,
	"./4.webp": 6797,
	"./5.webp": 3595,
	"./6.webp": 2295,
	"./7.webp": 3329,
	"./8.webp": 323
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9025;